<!------------ START TEMPLATE ------------>
<template>
  <div>
    <BrokersFilter
      @submit="updateFilters"
      @export="exportXls"
      :subjectPermission="subjectPermission"
    />
    <vx-card>
      <div id="data-list-list-view" class="data-list-container">
        <add-new-data-sidebar
          :isSidebarActive="addNewDataSidebar"
          @closeSidebar="addNewDataSidebar = false"
          :form="formSideBar"
          :title="titleSideBar"
          :dados="dadosSideBar"
          @concluido="concluido"
        />

        <vs-table
          noDataText="Nenhuma Corretora Encontrada"
          class="tablePrincipal"
          ref="table"
          multiple
          v-model="selected"
          :max-items="itemsPerPage"
          :data="itens"
        >
          <div
            slot="header"
            class="flex flex-wrap-reverse items-center flex-grow justify-between"
          >
            <div class="flex flex-wrap-reverse items-center">
              <!------------ START  MENU DE AÇÕES ------------>
              <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
                <div
                  class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32"
                >
                  <span class="mr-2">Ações</span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>

                <vs-dropdown-menu>
                  <vs-dropdown-item
                    @click="inativar"
                    v-if="$can($actionsDefault.Inativar, subjectPermission)"
                  >
                    <span>Inativar</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item
                    @click="reativar"
                    v-if="$can($actionsDefault.Inativar, subjectPermission)"
                  >
                    <span>Reativar</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="imprimir">
                    <span>Imprimir</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
              <!------------ END MENU DE AÇÕES ------------>

              <!------------ START ADD NOVO CORRETORA ------------>
              <div
                class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between font-medium text-base text-primary border border-solid border-primary"
                @click="openSideBar({})"
                v-if="$can($actionsDefault.Escrita, subjectPermission)"
              >
                <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                <span class="ml-2 text-base text-primary"
                  >Adicionar nova Corretora</span
                >
              </div>
            </div>
            <!------------ END ADD NOVO CORRETORA ------------>

            <div class="flex">
              <!------------ START ITENS POR PÁGINA ------------>
              <SelectPagination
                v-if="itens.length > 0"
                :currentPage="currentPage"
                :itemsPerPage="itemsPerPage"
                :length="count"
                @update="updateSelectPagination"
              />
              <!------------ END ITENS POR PÁGINA ------------>
            </div>
          </div>

          <!------------ START TITULO DA TABELA ------------>

          <template slot="thead">
            <vs-th sort-key="nome">Nome</vs-th>
            <vs-th sort-key="nomeDivisao">CNPJ</vs-th>
            <vs-th sort-key="estado">Estado</vs-th>
            <vs-th sort-key="cidade">Cidade</vs-th>
            <vs-th sort-key="assessoria">Assessoria</vs-th>
            <vs-th sort-key="convenio">Convênio</vs-th>
            <vs-th sort-key="deletedAt">Status</vs-th>
            <vs-th>Ações</vs-th>
          </template>
          <!------------ END TITULO DA TABELA ------------>

          <!------------ START TABELA ------------>
          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                  <p class="product-category">{{ tr.nome }}</p>
                </vs-td>

                <vs-td>
                  <p class="product-category">{{ tr.cnpj }}</p>
                </vs-td>

                <vs-td>
                  <p class="product-category">{{ tr.estado }}</p>
                </vs-td>

                <vs-td>
                  <p class="product-category">{{ tr.cidade }}</p>
                </vs-td>

                <vs-td>
                  <p v-if="tr.assessoria" class="product-category">
                    {{ tr.assessoria.nomeDivisao }}
                  </p>
                </vs-td>

                <vs-td>
                  <p v-if="tr.convenio" class="product-category">
                    {{ tr.convenio.nome }}
                  </p>
                </vs-td>

                <vs-td>
                  <vs-chip
                    :color="getStatusColor(tr.deletedAt)"
                    class="product-order-status"
                    >{{ getStatusString(tr.deletedAt) }}
                  </vs-chip>
                </vs-td>
                <vs-td class="w-48">
                  <div class="buttons-options-grid">
                    <vs-button
                      radius
                      v-tooltip="'Detalhes'"
                      color="dark"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-search"
                      class="button-option"
                      @click="openModal(tr.idRegional)"
                    />
                    <vs-button
                      radius
                      v-tooltip="'Editar'"
                      color="success"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-edit"
                      class="button-option"
                      @click="openSideBar(tr)"
                      v-if="$can($actionsDefault.Escrita, subjectPermission)"
                    />
                    <vs-button
                      radius
                      v-tooltip="'Histórico de Alterações'"
                      color="#88abc2"
                      icon-pack="feather"
                      icon="icon-archive"
                      class="button-option"
                      @click="abrirModalHistoricoUsuarios(tr)"
                    />
                    <vs-button
                      v-if="occurrencePermission"
                      radius
                      v-tooltip="'Ocorrências'"
                      color="warning"
                      icon-pack="feather"
                      icon="icon-clipboard"
                      class="button-option"
                      @click="openOccurrencesModal(tr)"
                    />
                  </div>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
        <!------------ END TABELA ------------>

        <div class="mt-6">
          <vs-pagination
            :total="parseInt(count / itemsPerPage) + 1"
            v-model="currentPage"
          ></vs-pagination>
        </div>

        <!------------ START INFORMAÇÕES DO CORRETORA ------------>
        <ModalInfo
          :modalSelecionado="modalSelecionado"
          :popupActive="popupActive"
          :title="`Dados da ${entidade}`"
          @close="popupActive = false"
        ></ModalInfo>

        <!------------ END INFORMAÇÕES DO CORRETORA ------------>
        <ModalHistoricoAlteracoes
          :popupActive="popupAlteracoesActive"
          :tipo="tipoHistorico"
          :nome="nomeHistorico"
          :dadosConsulta="dadosConsultaHistorico"
          @close="fecharModalHistorico"
        ></ModalHistoricoAlteracoes>

        <ModalShowAndCreateOccurrences
          v-if="occurrencePermission"
          :entityId="activeOccurrencesBroker"
          :popupActive="popupOccurrences"
          :saveOccurrenceApi="occurrenceApi.saveBrokerOccurrence"
          :getOccurrencesApi="occurrenceApi.getBrokerOccurrences"
          @close="popupOccurrences = false"
        />
      </div>
    </vx-card>
  </div>
</template>
<!------------ START TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import downloadexcel from 'vue-json-excel';
import ModalInfo from '../../components/ModalInfo';
import ModalHistoricoAlteracoes from '../modais/ModalHistoricoAlteracoes.vue';

import SelectPagination from '@/utils/list/header/SelectPagination.vue';
import BrokersFilter from '@/views/filtros/BrokersFilter.vue';
import service from '../../services';
import brokerApi from '../../services/broker.api.js';
import functions from '../../utils/functions';
import notify from '../../utils/notify';
import ModalShowAndCreateOccurrences from '../modais/ModalShowAndCreateOccurrences.vue';
import occurrenceApi from '../../services/occurrence.api';
import {
  PERMISSIONS_ACTIONS,
  PERMISSIONS_NAMES,
} from '../../constants/permissions';

export default {
  components: {
    BrokersFilter,
    ModalInfo,
    ModalHistoricoAlteracoes,
    SelectPagination,
    ModalShowAndCreateOccurrences,
  },
  props: {
    subjectPermission: {
      type: String,
      default: 'Corretora',
    },
  },
  data() {
    return {
      occurrenceApi,
      idEmpresa: null,
      dadosSideBar: {},
      controllerGeral: 'Regional',
      formSideBar: 'Escritorio',
      entidade: 'Corretora',
      titleSideBar: 'Adicionar Corretora',
      popupActive: false,
      modalSelecionado: [],
      selected: [],
      itens: [],
      colunas: {},
      itemsPerPage: 50,
      currentPage: 1,
      count: 0,
      filters: {},
      isMounted: false,
      addNewDataSidebar: false,
      debounce: functions.debounce(this.fetchData, 1000),
      dadosConsultaHistorico: [],
      tipoHistorico: 'Corretora',
      nomeHistorico: '',
      popupAlteracoesActive: false,
      popupOccurrences: false,
      activeOccurrencesBroker: null,
    };
  },
  computed: {
    occurrencePermission() {
      return this.$can(
        PERMISSIONS_ACTIONS.OCCURRENCE,
        PERMISSIONS_NAMES.BROKER,
      );
    },
  },
  watch: {
    currentPage() {
      this.fetchData();
    },
    itemsPerPage() {
      this.fetchData();
    },
  },
  methods: {
    imprimir() {
      setTimeout(function () {
        window.print();
      }, 500);
    },
    async exportXls() {
      const params = functions.cleanParams(this.filters);
      try {
        const response = await brokerApi.exportBrokersXls(params);
        const now = functions.formataDataMomentJS(
          new Date().toISOString(),
          'DD-MM-YYYY HH:mm',
        );

        const fileName = `Corretoras - ${now}.xlsx`;

        await functions.downloadFromBuffer(window, response, fileName);
      } catch (e) {
        notify.notifyFail(this.$vs, e);
      }
    },
    inativar() {
      if (this.selected.length > 0) {
        this.$vs.loading();
        var ids = [];
        this.selected.forEach((element) => {
          ids.push(element.idRegional);
        });
        service
          .post(this.controllerGeral, 'Inativar', { ids: ids })
          .then(() => {
            notify.notifySuccess(
              this.$vs,
              'Corretora(s) e todo os usuários vinculados à ela foram inativados com sucesso',
            );
            this.fetchData();
          })
          .catch((e) => notify.notifyFail(this.$vs, e))
          .finally(() => this.$vs.loading.close());
      } else {
        notify.notifyFail(this.$vs, 'Selecione pelo menos um registro');
      }
      this.selected = [];
    },
    reativar() {
      if (this.selected.length > 0) {
        this.$vs.loading();
        var ids = [];
        this.selected.forEach((element) => {
          ids.push(element.idRegional);
        });
        service
          .post(this.controllerGeral, 'Reativar', { ids: ids })
          .then(() => {
            notify.notifySuccess(this.$vs, 'Registro reativado(s) com sucesso');
            this.fetchData();
          })
          .catch((e) => notify.notifyFail(this.$vs, e))
          .finally(() => this.$vs.loading.close());
      } else {
        notify.notifyFail(this.$vs, 'Selecione pelo menos um registro');
      }
      this.selected = [];
    },
    updateFilters(filters) {
      this.filters = filters;
      this.currentPage = 1;
      this.fetchData();
    },
    async fetchData() {
      try {
        let url = `list-pagination/idEmpresa=${this.idEmpresa}`;

        if (this.currentPage && this.itemsPerPage) {
          url =
            url + `?page=${this.currentPage}&itemsPerPage=${this.itemsPerPage}`;
        }

        if (this.filters.name) {
          url = url + `&name=${this.filters.name}`;
        }
        if (this.filters.cnpj) {
          url = url + `&cnpj=${this.filters.cnpj}`;
        }
        if (
          this.filters.consultancies &&
          this.filters.consultancies.length > 0
        ) {
          url = url + `&consultancies=${this.filters.consultancies}`;
        }
        if (this.filters.covenants && this.filters.covenants.length > 0) {
          url = url + `&covenants=${this.filters.covenants}`;
        }

        this.$vs.loading();

        const res = await service.getAll(this.controllerGeral, {}, url);

        this.itens = res.data.rows;
        this.count = res.data.count;

        this.colunas = {};
        if (this.itens[0])
          Object.keys(this.itens[0]).forEach((element) => {
            if (
              element != 'createdAt' &&
              element != 'updatedAt' &&
              element != 'deletedAt' &&
              element.indexOf('id') != 0
            ) {
              this.colunas[element] = element;
            }
          });
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    updateSelectPagination(value) {
      this.currentPage = 1;
      this.itemsPerPage = value;
    },
    openSideBar(dados) {
      dados.idRegional == null
        ? (this.titleSideBar = `Adicionar ${this.entidade} `)
        : (this.titleSideBar = `Editar dados da ${this.entidade}`);
      this.dadosSideBar = dados;
      this.addNewDataSidebar = true;
    },
    openModal(cod) {
      this.modalSelecionado = [];
      this.popupActive = true;
      var item = this.itens.find((x) => x.idRegional == cod);
      Object.keys(item).forEach((element) => {
        if (
          element != 'createdAt' &&
          element != 'updatedAt' &&
          element != 'deletedAt' &&
          element != 'assessoria' &&
          element != 'convenio' &&
          element.indexOf('id') != 0
        )
          this.modalSelecionado.push({
            coluna: element,
            [element]: item[element],
          });
      });
    },
    concluido() {
      this.fetchData();
    },
    getStatusColor(data) {
      if (data == null) return 'success';
      return 'danger';
    },
    getStatusString(data) {
      if (data == null) return 'Ativo';
      return 'Inativo';
    },
    abrirModalHistoricoUsuarios(item) {
      this.dadosConsultaHistorico = [
        {
          tabela: 'regionais',
          id: item.idRegional,
        },
      ];
      this.nomeHistorico = item.nome;
      this.popupAlteracoesActive = true;
    },
    openOccurrencesModal(item) {
      this.activeOccurrencesBroker = item.idRegional;
      this.popupOccurrences = true;
    },
    fecharModalHistorico() {
      this.popupAlteracoesActive = false;
    },
  },
  created() {
    this.fetchData();
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>
<!------------ END SCRIPT ------------>

<!------------ START STYLE ------------>
<style lang="scss">
@media print {
  #content-area {
    margin-left: 0px;
  }
  .navbar-sticky .router-view .router-content {
    margin-top: 0px;
  }
  .vs-content-sidebar,
  .con-pagination-table,
  #data-list-list-view .vs-con-table .vs-table--header,
  .the-footer,
  .vs-navbar {
    display: none !important;
  }
  body,
  .vs-con-table .vs-con-tbody {
    background-color: #ffffff;
  }
  .vx-card,
  #data-list-list-view .vs-con-table .vs-table tr {
    box-shadow: none !important;
  }
  .td-check {
    visibility: hidden;
  }
}

#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>

<style lang="scss" scoped>
.buttons-options-grid {
  display: grid;
  grid-template-columns: repeat(2, 38px);
  gap: 6px;
}

.button-option {
  width: 38px;
  height: 38px;
}
</style>

<!------------ END STYLE ------------>
